import React, { Component } from 'react';
// import {
//     // BrowserRouter as Router,
//     Link
// } from 'react-router-dom';
import AWS from 'aws-sdk';
import './maindefinitions.css';
import './BasicTables.css';
import './MyOrdersPage.css';
import './basicforms.css';



class MyOrdersPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ordersTable: null,
            fullName: '',
            address: '',
            company: '',
            email: this.props.authData.attributes.email
        };


        this.handleCancelOrder = this.handleCancelOrder.bind(this);
        this.readOrdersTable = this.readOrdersTable.bind(this);
    }

    componentDidMount() {

        this.props.auth.currentCredentials()
            .then(credentials => {
                const dynamodb = new AWS.DynamoDB.DocumentClient({
                    region: 'us-east-1',
                    credentials: this.props.auth.essentialCredentials(credentials)
                });

                this.readOrdersTable(dynamodb);

                var userParams = {
                    ExpressionAttributeValues: {
                        ':id': this.props.authData.attributes.sub,
                    },
                    ExpressionAttributeNames: {
                        '#id': 'userId',
                    },
                    KeyConditionExpression: '#id = :id',
                    TableName: 'UserInfo'
                };

                dynamodb.query(userParams, (err, data) => {
                    if (err) {
                        console.log(err);
                        return null;
                    } else {
                        this.setState(
                            data.Items[0]
                        );
                    }
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    readOrdersTable(dynamodb) {
      var params = {
          ExpressionAttributeValues: {
              ':id': this.props.authData.attributes.sub,
          },
          ExpressionAttributeNames: {
              '#id': 'userId',
          },
          ScanIndexForward: false, //default true. false sets descending order
          KeyConditionExpression: '#id = :id',
          TableName: 'RoastedOrders'
      };

      dynamodb.query(params, (err, data) => {
          if (err) {
              console.log(err);
              return null;
          } else {
              if (data.Items) {
                if (data.Items.length) {
                  this.setState({
                      ordersTable: data.Items,
                  });
                } else {
                  this.setState({
                      ordersTable: null,
                  });
                }
                  console.log(data.Items);
              } else {
                  this.setState({
                      ordersTable: null,
                  });
                  console.log("ordersTable - null");
              }
          }
      });

    }

    handleCancelOrder(orderNumber) {
  		this.props.auth.currentCredentials()
  			.then(credentials => {
  				const dynamodb = new AWS.DynamoDB.DocumentClient({
  					region: 'us-east-1',
  					credentials: this.props.auth.essentialCredentials(credentials)
  				});
  				var params = {
            ExpressionAttributeValues: {
  						':newStatus': 'Cancelled',
              ':validStatus': 'Pending'
  					},
            Key: {
              'userId' : this.props.authData.attributes.sub,
              'orderNumber': orderNumber
            },
            UpdateExpression: 'SET #status = :newStatus',
            ExpressionAttributeNames: {
              '#status': 'orderStatus',
  						//'#itemInfo': id + 'info'
            },
            ConditionExpression: '#status = :validStatus'
            ,
  					// ReturnValues: 'ALL_NEW',
            // KeyConditionExpression: '#id = :id' ,
            TableName: 'RoastedOrders'
          };

  				dynamodb.update(params, (err, data) => {
  					if (err) {
  						console.log(err);
  						return null;
  					} else {
  						this.readOrdersTable(dynamodb);
  					}
  				});
  			})
  			.catch(error => {
  			console.log(error);
  		});
  	}

    render() {

        var myOrders;
        //var chosenSamplesInfo;

        if (this.state.ordersTable) {
            myOrders = this.state.ordersTable.map((doc, index) => {
              var orderDate = new Date(doc.orderTime);
                return (
                    <div key={doc.orderNumber} className="myorders-table-container">
                        <table className="myorders-table">
                        <tbody>
                          <tr className="basicforms">
                              <th>{/*
                                    <input disabled type="submit" value="Cup Samples" />
                                    */}
                                    { (doc.orderStatus === 'Pending') &&
                                      <input type="button" value="Cancel order" onClick={() => this.handleCancelOrder(doc.orderNumber)} />
                                        }
                                       
                                        <div className="col-20">
                                            <p className="myorders-tabletitle2"> PEDIDO# {doc.orderNumber} </p>
                                            <p className="myorders-tabletitle">{orderDate.toDateString()}</p>                                         
                                            
                                        </div>
                                        <div className="col-20">
                                            <p className="myorders-tabletitle2"> TOTAL </p>
                                            <p className="myorders-tabletitle"> R$ {doc.total}</p>
                                        </div>
                                        
                                        <div className="col-20">
                                            <p className="myorders-tabletitle2"> ENTREGA</p>
                                            <p className="myorders-tabletitle">{doc.delivery}</p>
                                        </div>
                                        <div className="col-20">
                                            <p className="myorders-tabletitle2"> STATUS</p>
                                            <p className="myorders-tabletitle">{doc.orderStatus}</p>
                                        </div>
                                      

                              </th>
                          </tr>
                          <tr><td><table className="myorders-table"><tbody>
                              <tr>
                                <td><b>Selected Samples</b></td>
                                <td><b>id</b></td>
                                <td><b>Dia da Torra</b></td>
                                <td><b>Preço</b></td>
                                <td><b>Quantidade</b></td>
                                <td><b>Total do Item</b></td>
                               </tr>
                          {doc.chosenLots.map((lot, i) => {
                            var roastDate = new Date(lot.info[2] * 1000);
                            return (
                              <tr key={doc.orderNumber + i}>
                                <td>{lot.info[0]}</td>
                                <td>{lot.id}</td>
                                <td>{roastDate.toDateString()}</td>
                                <td>R$ {lot.price}</td>
                                <td>{lot.quantity}</td>
                                <td>R$ {lot.price * lot.quantity}</td>
                              </tr>
                            )
                          })
                          }</tbody></table></td></tr>
                        </tbody>
                        </table>
                        </div>

                );
            });
        } else {
            myOrders = <p>No orders</p>;
        }


        return (
            <div >
                <div className='textsnarrow'>
                    <p className="pagetitle">My Orders</p>
                </div>
                <div>
                  {myOrders}
                </div>
            </div>

        );
    }
}


export default MyOrdersPage;



// WEBPACK FOOTER //
// ./src/components/MyOrdersPage.js